import { render } from "./YPCompanyDetail.vue?vue&type=template&id=483d25a5"
import script from "./YPCompanyDetail.vue?vue&type=script&lang=js"
export * from "./YPCompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__